// Any config specific to BAHRAIN?

export default {
  code: 'BHR',
  countryName: 'Bahrain',
  googleSiteVerificationCode: [
    'LVneaZHf1h8BShbZXOIQGmQ_xcinQsOPltci6L3HJHc',
    '73IB1dl7efAAzQXb3onUudU9wVcHmz_KC-sxtKbbwXg',
    'pKA2y4zeYHVGlXyg4_bcUx1DhaiTwyxkYf3Xe4kEMfs'
  ],
  countryDomain: 'https://www.carrefourbahrain.com',
  helplineNumber: '800 73232',
  latitude: 26.20926164864932, // TODO need to update for behrain in country switching default lat long not coming
  longitude: 50.45117116051133,
  defaultAreaCode: 'Budaiya - Northern Governorate',
  features: {
    languageChange: false,
    now: false,
    share: false,
    isLocationCXEnable: false,
    cashback: false,
    linkMyClubCard: false,
    oneTrustScript: 'fbc7bbeb-e5a9-461d-afe6-5fed9fcd620a'
  }
}
